export default __webpack_public_path__ + "assets/cb6d327f14212d1c2c4de81623dc2577.svg";